import { createSelector } from 'reselect';

export const getHistoricalAccesor = state => state.tickets.historical;

export const historicalSelector = createSelector(getHistoricalAccesor, historical => historical);
